import { Box, Button, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';

interface SummaryDrawerActionsProps {
  modalMargins: number;
  onContinueButtonClick: () => void;
  disabled: boolean;
  clearCart?: () => void;
  clearCartDisabled?: boolean;
}

const SummaryDrawerActions: React.FC<SummaryDrawerActionsProps> = ({
  modalMargins,
  onContinueButtonClick,
  disabled,
  clearCart,
  clearCartDisabled,
}) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box
      sx={{
        flexShrink: 0,
        py: 2,
        px: isSmallScreen ? 1.5 : 3,
        mx: -modalMargins,
        mb: -modalMargins,
        borderRadius: 2,
        textAlign: 'center',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          gap: 1,
        }}
      >
        {clearCart && (
          <Button
            variant="outlined"
            color="primary"
            sx={{
              textTransform: 'none',
              width: isSmallScreen ? '100%' : undefined,
            }}
            disabled={clearCartDisabled}
            onClick={clearCart}
          >
            Clear Cart
          </Button>
        )}
        <Button
          variant="contained"
          color="primary"
          sx={{
            textTransform: 'none',
            width: isSmallScreen ? '100%' : undefined,
          }}
          disabled={disabled}
          onClick={() => onContinueButtonClick()}
        >
          Checkout
        </Button>
      </Box>
    </Box>
  );
};

export default SummaryDrawerActions;
